export default "__VITE_ASSET__phVsqplO__"